var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadcover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#EBEAEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9954 25.831C38.6089 20.3075 33.0073 16.9538 27.4838 18.3404C23.1673 19.4239 20.0331 23.1546 19.7101 27.5932C16.6453 28.0987 14.5704 30.9929 15.0758 34.0578C15.5251 36.7825 17.8861 38.778 20.6475 38.767H25.3345V36.8922H20.6475C18.5767 36.8922 16.8979 35.2135 16.8979 33.1426C16.8979 31.0718 18.5767 29.393 20.6475 29.393C21.1653 29.393 21.5849 28.9734 21.5849 28.4556C21.5802 23.7962 25.3537 20.0152 30.0131 20.0106C34.0465 20.0066 37.5185 22.858 38.2987 26.8152C38.3363 27.0079 38.4334 27.1839 38.5764 27.3185C38.7193 27.453 38.9009 27.5393 39.0955 27.5651C41.6582 27.93 43.4398 30.3034 43.0749 32.866C42.7473 35.1672 40.7825 36.8806 38.4581 36.8922H34.7085V38.767H38.4581C42.0821 38.7561 45.011 35.8093 44.9999 32.1854C44.9908 29.1687 42.926 26.5469 39.9954 25.831Z",
    fill: "#686868"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3551 29.6649L25.6055 33.4145L26.9272 34.7363L29.0832 32.5896V41.5793H30.958V32.5896L33.1046 34.7363L34.4264 33.4145L30.6768 29.6649C30.3111 29.3015 29.7207 29.3015 29.3551 29.6649Z",
    fill: "#686868"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadcover);
export default __webpack_public_path__ + "static/media/uploadcover.11dedb8428dbca2e13a32b5ac5379fc4.svg";
export { ForwardRef as ReactComponent };